export enum DripIcons {
  Pencil,
  Gear,
  GraphBar,
  Question,
  Exit,
  User,
  Search,
  Approve,
  Subscriptions,
  Stripe,
}

interface IProps {
  icon: DripIcons;
  className: string;
}

export const DripIcon = ({ icon, className }: IProps) => {
  switch (icon) {
    case DripIcons.Pencil:
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 92 92">
          <path
            className={className}
            d="M89.1 6.1l-3.2-3.2C84 1 81.6 0 78.9 0s-5.1 1-7 2.9L8.7 66.2c-.4.4-.7.8-.9 1.4L.3 86.5c-.6 1.5-.3 3.2.9 4.3C1.9 91.6 3 92 4 92c.5 0 1-.1 1.5-.3l19-7.4c.5-.2 1-.5 1.4-.9l63.3-63.3c3.8-3.8 3.8-10.1-.1-14zM14.8 71.7l5.6 5.6-9.3 3.6 3.7-9.2zm68.6-57.2L28.2 69.7l-5.8-5.8L77.5 8.6c.5-.5 1.1-.6 1.4-.6s.9.1 1.4.6l3.2 3.2c.7.7.7 1.9-.1 2.7z"
          />
        </svg>
      );
    case DripIcons.Gear:
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 92 92">
          <path
            className={className}
            d="M46 65.3c-10.6 0-19.3-8.6-19.3-19.3 0-10.6 8.6-19.3 19.3-19.3 10.6 0 19.3 8.6 19.3 19.3 0 10.6-8.7 19.3-19.3 19.3zm0-31.5c-6.7 0-12.2 5.5-12.2 12.2 0 6.7 5.5 12.2 12.2 12.2 6.7 0 12.2-5.5 12.2-12.2 0-6.7-5.5-12.2-12.2-12.2zM46 92h-.5c-3.5 0-6.5-.4-6.7-.4-1.6-.2-2.8-1.4-3.1-3l-1-7.2c-2.2-.7-4.3-1.6-6.3-2.7L22.8 83c-1.3 1-3 .9-4.3 0-.1-.1-2.5-2-5-4.4l-.4-.4c-2.5-2.5-4.3-4.9-4.4-5-1-1.3-1-3 0-4.3l4.4-5.8c-1.1-2-1.9-4.2-2.6-6.4l-7-1c-1.6-.2-2.8-1.5-3-3.1-.1-.1-.5-3.1-.5-6.6v-.5c0-3.5.4-6.5.4-6.7.2-1.6 1.4-2.8 3-3.1l7.2-1c.7-2.2 1.6-4.3 2.7-6.3L9 22.8c-1-1.3-.9-3 0-4.3.1-.1 2-2.5 4.4-5l.4-.4c2.5-2.5 4.9-4.3 5-4.4 1.3-1 3-1 4.3 0l5.8 4.4c2-1.1 4.2-1.9 6.4-2.6l1-7c.2-1.6 1.5-2.8 3.1-3C39.5.4 42.5 0 46 0h.5c3.5 0 6.5.4 6.7.4 1.6.2 2.8 1.4 3.1 3l1 7.2c2.2.7 4.3 1.6 6.3 2.7L69.2 9c1.3-1 3-.9 4.3 0 .1.1 2.5 2 5 4.4l.4.4c2.5 2.5 4.3 4.9 4.4 5 1 1.3 1 3 0 4.3L79 28.9c1.1 2 1.9 4.2 2.6 6.4l7 1c1.6.2 2.8 1.5 3 3.1 0 .1.4 3.2.4 6.7v.5c0 3.5-.4 6.5-.4 6.7-.2 1.6-1.4 2.8-3 3.1l-7.2 1c-.7 2.2-1.6 4.3-2.7 6.3l4.3 5.7c1 1.3.9 3 0 4.3-.1.1-2 2.5-4.4 5l-.4.4c-2.5 2.5-4.9 4.3-5 4.4-1.3 1-3 1-4.3 0L63.1 79c-2 1.1-4.2 1.9-6.4 2.6l-1 7c-.2 1.6-1.5 2.8-3.1 3-.1 0-3.1.4-6.6.4zm-3.6-7.2c.9.1 2 .1 3.1.1h.5c1.1 0 2.2 0 3.1-.1l.9-6.6c.2-1.5 1.3-2.6 2.7-3 3.1-.7 6.1-1.9 8.8-3.6.8-.5 1.8-.6 2.7-.4.5.1 1 .4 1.4.7l5.3 4c.7-.6 1.5-1.3 2.3-2.1l.4-.4c.8-.8 1.5-1.6 2.1-2.3l-4-5.3c-.9-1.2-.9-2.8-.2-4 1.7-2.6 2.9-5.5 3.6-8.5.3-1.5 1.5-2.7 3-2.9l6.7-.9c.1-.9.1-2 .1-3.1V46c0-1.1 0-2.2-.1-3.1l-6.6-.9c-1.4-.2-2.6-1.3-3-2.7-.7-3.1-1.9-6-3.5-8.7-.2-.2-.3-.5-.4-.8-.4-1.1-.2-2.4.5-3.3l4.1-5.4c-.6-.7-1.3-1.5-2.1-2.3l-.4-.4c-.8-.8-1.6-1.5-2.3-2.1l-5.3 4c-1.3.9-3 .9-4.2 0-2.6-1.6-5.5-2.8-8.5-3.6-1.4-.3-2.5-1.5-2.7-3L49.5 7c-.9-.1-2-.1-3.1-.1H46c-1.1 0-2.2 0-3.1.1l-.9 6.8c-.2 1.6-1.4 2.8-3 3-3 .7-5.9 1.9-8.5 3.5-.8.5-1.8.6-2.7.4-.5-.1-1-.4-1.4-.7l-5.2-4c-.7.6-1.5 1.3-2.3 2.1l-.4.4c-.8.8-1.5 1.6-2.1 2.3l4 5.3c.9 1.2.9 2.7.2 4-.1.1-.1.2-.2.3-1.6 2.6-2.8 5.5-3.5 8.5-.3 1.4-1.5 2.5-3 2.7l-6.7.9c-.1.9-.1 2-.1 3.1v.4c0 1.1 0 2.2.1 3.1l6.6.9c1.6.2 2.8 1.4 3 3v.1c.7 3 1.9 5.8 3.5 8.4.5.9.7 2 .3 3-.1.4-.4.8-.7 1.2L16 70.9c.6.7 1.3 1.5 2.1 2.3l.4.4c.8.8 1.6 1.5 2.3 2.1l5.3-4c1.3-1 3.2-.9 4.4.1 2.6 1.6 5.4 2.7 8.3 3.5 1.4.3 2.5 1.5 2.7 3l.9 6.5z"
          />
        </svg>
      );
    case DripIcons.GraphBar:
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 92 92">
          <path
            className={className}
            d="M73 89c-3.3 0-6-2.7-6-6V9c0-3.3 2.7-6 6-6s6 2.7 6 6v74c0 3.3-2.7 6-6 6zm-21-6V33.4c0-3.3-2.7-6-6-6s-6 2.7-6 6V83c0 3.3 2.7 6 6 6s6-2.7 6-6zm-27 0V57.8c0-3.3-2.7-6-6-6s-6 2.7-6 6V83c0 3.3 2.7 6 6 6s6-2.7 6-6z"
          />
        </svg>
      );
    case DripIcons.Question:
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 92 92">
          <path
            className={className}
            d="M60.9 25.5c3.2 3.6 4.7 8.5 4 13.7-1.2 9.6-8.2 13-14.4 13H50v2.4c0 2.2-1.8 4-4 4s-4-1.8-4-4v-3.2c0-3.3 1.4-7.2 8.5-7.2 3.9 0 5.9-2 6.4-6 .2-1.3.3-4.8-2.1-7.4-1.9-2.1-5-3.2-9.2-3.2-9 0-9.3 5.9-9.3 6.5 0 2.2-1.8 4-4 4s-4-1.8-4-4c0-4 3.1-14.5 17.3-14.5 8.3 0 12.9 3.2 15.3 5.9zM45.7 62c-1.3 0-2.6.5-3.5 1.5-.9.9-1.5 2.2-1.5 3.5 0 1.3.5 2.6 1.5 3.5.9.9 2.2 1.5 3.5 1.5 1.3 0 2.6-.5 3.5-1.5.9-.9 1.5-2.2 1.5-3.5 0-1.3-.5-2.6-1.5-3.5-.9-.9-2.1-1.5-3.5-1.5zM92 46c0 25.4-20.6 46-46 46S0 71.4 0 46 20.6 0 46 0s46 20.6 46 46zm-8 0C84 25 67 8 46 8S8 25 8 46s17 38 38 38 38-17 38-38z"
          />
        </svg>
      );
    // this one is not actually a drip icon, but is what was specified in the mockup
    case DripIcons.Exit:
      return (
        <svg viewBox="0 0 16 17" xmlns="http://www.w3.org/2000/svg">
          <path
            className={className}
            d="M8.76363 10.7846C9.05179 11.1241 9.0492 11.6718 8.75788 12.0078C8.61325 12.1745 8.42485 12.2578 8.23627 12.2578C8.04509 12.2578 7.8541 12.1722 7.70909 12.0011L4.80581 8.5788C4.51987 8.24194 4.51987 7.69947 4.80581 7.36239L7.70909 3.94035C7.99707 3.60067 8.46694 3.59804 8.75788 3.93361C9.0492 4.26961 9.05179 4.8173 8.76363 5.15676L7.10626 7.1103L16.0969 7.13513C16.5065 7.13621 16.8378 7.52436 16.8369 8.00199C16.8358 8.47896 16.5041 8.86487 16.0952 8.86487H16.0933L7.11405 8.84026L8.76363 10.7846ZM0.890068 0.864874V15.1351C0.890068 15.6127 1.22199 16 1.6316 16H11.2983C11.7079 16 12.0159 15.6127 12.0159 15.1351V11.1799C12.0159 10.7023 11.6838 10.315 11.2742 10.315C10.8646 10.315 10.5325 10.7023 10.5325 11.1799V14.2703H2.37351V1.72975H10.5325V4.82012C10.5325 5.29774 10.8646 5.68499 11.2742 5.68499C11.6838 5.68499 12.0159 5.29774 12.0159 4.82012V0.864874C12.0159 0.387251 11.7079 0 11.2983 0H1.6316C1.22199 0 0.890068 0.387251 0.890068 0.864874Z"
          />
        </svg>
      );
    case DripIcons.User:
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 92 92">
          <path
            className={className}
            d="M46 57.1c14.8 0 26.9-12.1 26.9-27C72.9 15.1 60.8 3 46 3S19.1 15.1 19.1 30c0 15 12.1 27.1 26.9 27.1zM46 11c10.4 0 18.9 8.5 18.9 19S56.4 49 46 49s-18.9-8.5-18.9-19S35.6 11 46 11zm12.5 48.7c-1.3-.4-2.8-.1-3.8.8L46 67.9l-8.7-7.4c-1.1-.9-2.5-1.2-3.8-.8C27.9 61.5 0 71.1 0 85c0 2.2 1.8 4 4 4h84c2.2 0 4-1.8 4-4 0-13.9-27.9-23.5-33.5-25.3zM10.1 81c4.4-4.7 15-9.9 23.8-12.9l9.5 8.1c1.5 1.3 3.7 1.3 5.2 0l9.5-8.1c8.8 3.1 19.4 8.3 23.8 12.9H10.1z"
          />
        </svg>
      );
    case DripIcons.Search:
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 92 92">
          <path
            className={className}
            d="M57.8,2.2c-17.1,0-31,14.1-31,31.3c0,7.3,2.5,13.9,6.6,19.3L4,82.6c-1.7,1.8-1.7,4.6,0,6.3
            c0.9,0.9,2,1.3,3.1,1.3c1.2,0,2.3-0.4,3.2-1.3l29.4-29.8c5.1,3.7,11.3,5.8,18,5.8c17.1,0,31-14.1,31-31.3S74.9,2.2,57.8,2.2z
             M57.8,57c-12.7,0-23-10.5-23-23.4c0-12.9,10.3-23.4,23-23.4c12.7,0,23,10.5,23,23.4C80.8,46.5,70.5,57,57.8,57z M73.3,34
            c-0.2,1.7-1.7,3-3.4,3c-0.2,0-0.3,0-0.5,0c-1.9-0.3-3.2-2-3-3.9c0.7-5.2-5.1-7.9-5.4-8c-1.7-0.8-2.5-2.9-1.7-4.6s2.8-2.5,4.6-1.8
            C64.3,18.8,74.7,23.6,73.3,34z M66,41.6c0.7,0.7,1.2,1.8,1.2,2.8c0,1.1-0.4,2.1-1.2,2.8c-0.7,0.7-1.8,1.2-2.8,1.2
            c-1,0-2.1-0.4-2.8-1.2c-0.7-0.7-1.2-1.8-1.2-2.8c0-1,0.4-2.1,1.2-2.8c0.7-0.7,1.8-1.2,2.8-1.2C64.2,40.4,65.2,40.8,66,41.6z"
          />
        </svg>
      );
    case DripIcons.Approve:
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 92 92">
          <path
            className={className}
            d="M34.4,72c-1.2,0-2.3-0.4-3.2-1.3L11.3,50.8c-1.8-1.8-1.8-4.6,0-6.4c1.8-1.8,4.6-1.8,6.4,0l16.8,16.7
            l39.9-39.8c1.8-1.8,4.6-1.8,6.4,0c1.8,1.8,1.8,4.6,0,6.4l-43.1,43C36.7,71.6,35.6,72,34.4,72z"
          />
        </svg>
      );
    case DripIcons.Subscriptions:
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 92 92">
          <path
            className={className}
            d="M76,2H16c-2.2,0-4,1.8-4,4v80c0,2.2,1.8,4,4,4h60c2.2,0,4-1.8,4-4V6C80,3.8,78.2,2,76,2z M72,82H20V10h52
            V82z M29.5,55.5c0-1.9,1.6-3.5,3.5-3.5h11.8c1.9,0,3.5,1.6,3.5,3.5S46.7,59,44.8,59H33C31,59,29.5,57.4,29.5,55.5z M30,39.5
            c0-1.9,1.6-3.5,3.5-3.5h23.8c1.9,0,3.5,1.6,3.5,3.5S59.3,43,57.3,43H33.5C31.6,43,30,41.4,30,39.5z M30,24.5c0-1.9,1.6-3.5,3.5-3.5
            h23.8c1.9,0,3.5,1.6,3.5,3.5S59.3,28,57.3,28H33.5C31.6,28,30,26.4,30,24.5z M59.7,53.3c0.6,0.6,1,1.5,1,2.5c0,0.9-0.4,1.8-1,2.5
            s-1.6,1-2.5,1s-1.8-0.4-2.5-1c-0.7-0.6-1-1.5-1-2.5c0-0.9,0.4-1.8,1-2.5C56,52,58.4,52,59.7,53.3z"
          />
        </svg>
      );
    case DripIcons.Stripe:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="16" height="16" rx="2" fill="white" />
          <path
            d="M8.23679 5.4641C7.62471 5.4641 7.25516 5.63443 7.25516 6.07729C7.25516 7.34908 11.6552 6.74725 11.6667 10.1311C11.6667 12.1637 10.0153 13.3333 7.61316 13.3333C6.61999 13.3333 5.53442 13.1403 4.46041 12.6861V9.98352C5.43049 10.5059 6.65463 10.8919 7.61316 10.8919C8.25988 10.8919 8.72183 10.7216 8.72183 10.1993C8.72183 8.84799 4.33337 9.34762 4.33337 6.21355C4.33337 4.20366 5.89243 3 8.23679 3C9.19532 3 10.1423 3.14762 11.1008 3.52234V6.19084C10.2231 5.72528 9.11448 5.4641 8.23679 5.4641Z"
            fill="#4B5F9C"
          />
        </svg>
      );
  }
};
